import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterDocumentDateCustomTypes,
  FilterDocumentDateFilterTypes,
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  Timestamp,
} from '@griply/types';
import { subDays } from 'date-fns';

// Limit completed tasks to a recent window so we don't fetch the entire
// task history from Firestore on each visit.
export const COMPLETED_LOOKBACK_DAYS = 14;

export const createDefaultFilter = (today: Timestamp): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.CompletedDate,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  showCompleted: true,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.CompletedAt]: {
      type: FilterDocumentDateFilterTypes.Custom,
      custom: {
        type: FilterDocumentDateCustomTypes.After,
        start: subDays(today, COMPLETED_LOOKBACK_DAYS),
        end: null,
      },
    },
  },
});
